import { Injectable, inject } from '@angular/core';

import { mergeMap } from 'rxjs/operators';

import { Actions, createEffect, ofType } from '@ngrx/effects';

import { safeMap } from '@era/stores';
import { AppleDevicesService, ManagedApplication } from '@rocksoft/mdm-sdk-v2';
import { ManagedApplicationsApiActions, ManagedApplicationsContainerActions } from './managed-applications.actions';

@Injectable()
export class ManagedApplicationsEffects {
  private readonly appleDeviceService = inject(AppleDevicesService);
  private readonly actions$ = inject(Actions);

  managedApplicationsRequestedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ManagedApplicationsContainerActions.managedApplicationRequested),
      mergeMap((action) =>
        safeMap(
          this.appleDeviceService.getManagedApplications({ udid: action.udid, apiVersion: '2.0' }),
          (managedApplications: ManagedApplication[]) =>
            ManagedApplicationsApiActions.managedApplicationsLoaded({ managedApplications }),
          (error) => ManagedApplicationsApiActions.managedApplicationsLoadedError({ error })
        )
      )
    );
  });
}
